import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RelatedCardActions, RelatedCardEpics, RelatedCardFacade } from './+state';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [RelatedCardActions, RelatedCardFacade, RelatedCardEpics]
})
export class RelatedCardModule {}
